<template>
    <div>
        <!-- <h1>Viewer图片预览插件</h1> -->
        <viewer :images="viewerList">
            <img
                    v-for="src in viewerList"
                    :src="src.url"
                    :key="src.id"
                    style="height: 120px; margin-right: 5px;max-width:100%;vertical-align: middle; "
            />
        </viewer>
    </div>
</template>

<script>
export default {
    name: "ViewerPreview",
    props: {
        viewerList: {
            type: Array,
            default: [],
        },
    },
    mounted() {
    },
    data() {
        return {};
    },
};
</script>

<style scoped>
</style>